export const DEFAULT_GROUP_RELEVANCE_ID = 1;
